/**
 * Лестница углеводов — зеркало `shared/services/workout_fueling.py`.
 *
 * ЗАЧЕМ ЗЕРКАЛО, А НЕ ВТОРОЙ РАСЧЁТ. Ручной калькулятор на
 * `/carb-timing` пересчитывается на каждое движение ползунка — ходить
 * за этим на сервер бессмысленно. Но числа он обязан давать ТЕ ЖЕ, что
 * приходят на карточке тренировки: две цифры углеводов на одну и ту же
 * работу читаются как ошибка, и человек перестаёт верить обеим.
 *
 * Раньше здесь стояла своя шкала (30/40/70 г/ч по одной лишь
 * интенсивности), а на бэкенде — своя, ещё и по длительности. На
 * трёхчасовой тяжёлой работе они расходились на 15 г/ч.
 *
 * Парность держит `scripts/check_fueling_ladder_parity.py`: он читает
 * константы из обоих файлов и падает при расхождении. Меняешь ступень —
 * меняй в обоих местах, иначе коммит не пройдёт.
 */

export const CHO_FREE_MINUTES = 45;
export const CHO_SHORT_MINUTES = 75;
export const CHO_MID_MINUTES = 150;
export const CHO_LONG_MINUTES = 210;

export const CHO_SHORT_INTENSE_G = 25;
export const CHO_MID_G = 40;
export const CHO_MID_INTENSE_G = 60;
export const CHO_LONG_G = 70;
export const CHO_LONG_INTENSE_G = 85;
export const CHO_ULTRA_G = 90;
export const CHO_GUT_TRAINED_G = 120;

export const INTENSE_IF = 0.85;
export const MODERATE_IF = 0.78;

/** Углеводы в час: длительность задаёт ступень, интенсивность поднимает. */
export function carbsPerHour(
  durationMinutes: number,
  intensity: number,
  gutTrained = false,
): number {
  if (durationMinutes < CHO_FREE_MINUTES) return 0;
  if (durationMinutes < CHO_SHORT_MINUTES) {
    return intensity >= INTENSE_IF ? CHO_SHORT_INTENSE_G : 0;
  }
  if (durationMinutes < CHO_MID_MINUTES) {
    return intensity >= MODERATE_IF ? CHO_MID_INTENSE_G : CHO_MID_G;
  }
  if (durationMinutes < CHO_LONG_MINUTES) {
    return intensity >= MODERATE_IF ? CHO_LONG_INTENSE_G : CHO_LONG_G;
  }
  return gutTrained ? CHO_GUT_TRAINED_G : CHO_ULTRA_G;
}

/**
 * Словесная интенсивность ручного калькулятора → фактор.
 *
 * Ползунок даёт «лёгкая / средняя / тяжёлая», а лестница считает по
 * доле от порога. Значения выбраны так, чтобы попадать в те же ступени:
 * лёгкая ниже умеренного порога, тяжёлая выше интенсивного.
 */
export function intensityFactorOf(level: "light" | "moderate" | "hard"): number {
  if (level === "hard") return 0.9;
  if (level === "moderate") return 0.8;
  return 0.65;
}
